if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        const menuOverlay = document.getElementById("menu-overlay-quick");
        if (menuOverlay) {
          menuOverlay.classList.add("hidden");
          menuOverlay.style.top = "";
        }

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const menuOverlay = document.getElementById("menu-overlay-quick");
        if (menuOverlay) {
          menuOverlay.classList.remove("hidden");
          menuOverlay.style.top = "0";
        }

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            if (!productElement) return;

            const newProductInfo = document.createElement('product-info');

            Array.from(productElement.attributes).forEach(attr => {
              newProductInfo.setAttribute(attr.name, attr.value);
            });

            const elementsToInclude = [
              '#assets-mainprod',
              '.product__title',
              '.price--large',
              '.color_variant_name',
              'variant-selects',
              '.product-form',
            ];

            elementsToInclude.forEach(selector => {
              const element = productElement.querySelector(selector);
              if (element) {
                const cloned = element.cloneNode(true);


                if (selector === 'variant-selects') {
                  cloned.classList.remove('mt-5', 'md:mt-12', 'md:text-[14px]');
                  cloned.classList.add('md:text-[12px]', 'mb-6');
                }

                if (selector === '.color_variant_name') {
                  cloned.classList.remove('text-[14px]');
                  cloned.classList.add('text-[12px]', 'mb-6');
                }
                newProductInfo.appendChild(cloned);
              }
            });


            const productUrl = productElement.getAttribute("data-url");

            if (productUrl) {
              const customLink = document.createElement("a");
              customLink.textContent = "Scopri di più";
              customLink.href = productUrl;
              customLink.classList.add("underline", "mt-4", "b2", "text-center");
              customLink.setAttribute('data-quick-view-link', ''); // Add a data attribute for identification
              newProductInfo.appendChild(customLink);
            }

            const swiperContainer = document.createElement('div');
            swiperContainer.classList.add('swiper', 'w-full', 'max-w-full', 'overflow-hidden');

            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper-wrapper');

            const mediaElements = productElement.querySelectorAll('.main-product-image img');

            mediaElements.forEach((img, index) => {
              const slide = document.createElement('div');
              slide.classList.add('swiper-slide', 'w-full');

              const imgClone = img.cloneNode(true);
              imgClone.classList.add('w-full', 'h-auto');

              slide.appendChild(imgClone);
              swiperWrapper.appendChild(slide);
            });

            swiperContainer.appendChild(swiperWrapper);
            swiperContainer.innerHTML += `
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-pagination"></div>
                `;

            const containerDiv = document.createElement('div');
            containerDiv.classList.add('flex', 'w-full');

            const leftColumn = document.createElement('div');
            leftColumn.classList.add('w-1/2', 'max-w-[50%]', 'overflow-hidden');
            leftColumn.appendChild(swiperContainer);

            const rightColumn = document.createElement('div');
            rightColumn.classList.add('w-1/2', 'px-4');
            rightColumn.appendChild(newProductInfo);

            containerDiv.appendChild(leftColumn);
            containerDiv.appendChild(rightColumn);

            this.preprocessHTML(containerDiv);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, containerDiv.outerHTML);


            this.modalContent.addEventListener('click', (event) => {
              const linkElement = event.target.closest('[data-quick-view-link]');
              if (!linkElement) return;
              
              Shopify.analytics.publish('preview_popup', { 
                'product': document.querySelector('product-info').dataset.productId,
                'sku': JSON.parse(document.querySelector('variant-selects [data-selected-variant]')?.innerHTML).sku,
                'position': 'view_details',
              });
            });



            setTimeout(() => {
              const modal = this.modalContent;

              const radios = modal.querySelectorAll('input[type="radio"]');
              const submitButton = modal.querySelector('product-form button[type="submit"]');
              const errorMessage = modal.querySelector('[data-size-error]');

              if (!submitButton || radios.length === 0) return;

              const checkIfVariantSelected = () => {
                const isSelected = Array.from(radios).some(radio => radio.checked);

                if (isSelected) {
                  submitButton.removeAttribute('aria-disabled');
                  if (errorMessage) {
                    errorMessage.classList.add('hidden');
                    errorMessage.style.display = 'none';
                  }
                } else {
                  submitButton.setAttribute('aria-disabled', 'true');
                }
              };

              checkIfVariantSelected();

              radios.forEach((radio) => {
                radio.addEventListener('change', checkIfVariantSelected);
              });

              submitButton.addEventListener('click', (e) => {
                const isDisabled = submitButton.getAttribute('aria-disabled') === 'true' || submitButton.disabled;

                if (isDisabled) {
                  e.preventDefault();      // blocca invio form
                  e.stopImmediatePropagation(); // blocca altri handler Shopify
                  if (errorMessage) {
                    errorMessage.classList.remove('hidden');
                    errorMessage.style.display = 'block'; // forza visibilità
                  }
                }
              });
            }, 300);





            setTimeout(() => {
              new Swiper(".swiper", {
                loop: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
              });
            }, 300);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
